var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasPermission('access lms'))?_c('a',{staticClass:"navbar-item is-flex is-align-content-center",attrs:{"title":"Log into LMS"},on:{"click":_vm.LoginIntoLMS}},[_c('b-icon',{attrs:{"custom-size":"default","icon":"logout"}}),_c('span',[_vm._v("Log into LMS")]),(_vm.loading)?_c('GenexMiniLoader',{staticClass:"ml-2"}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }